import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const courseDetailsCrudStateConfig: CrudConfig = {
  name: "courseDetails",
  path: "seneca/course/meta/",
  callTypes: [AllowedCallTypes.FETCH]
};

export const courseCrudStateConfig: CrudConfig = {
  name: "course",
  path: "seneca/course/meta/",
  idFieldName: "id",
  callTypes: [AllowedCallTypes.FETCH]
};

export const courseSectionsCrudStateConfig: CrudConfig = {
  name: "courseSections",
  path: "seneca/course/meta/",
  idFieldName: "id",
  callTypes: [AllowedCallTypes.FETCH]
};

export const sectionCrudStateConfig: CrudConfig = {
  name: "section",
  path: "seneca/course/meta/",
  idFieldName: "id",
  callTypes: [AllowedCallTypes.FETCH]
};

export const PATH_TO_COURSES_STATE = "courses";
